// extracted by mini-css-extract-plugin
export default {"systemMenu":"WQP19Ka43P0LhGZ1cTVu"};